import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FuelSupplyList from './FuelSupplyList';
import { useParams } from 'react-router-dom';  
import useRedirectEstablishmentActiveContent from '../../../Components/Hooks/useRedirectEstablishmentActiveContent';

//redux

const FuelSupply = () => {
	const { id } = useParams();
	const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/supply/fuel-supply/establishmentId');

	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Abastecimiento', icon: 'icon-shopping-basket' },
		{ to: '#', label: 'Combustible', icon: 'icon-fuel' },
	];


	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Movimiento de Combustible' links={breadcrumbLinks} icon={'icon-fuel'} />
					<FuelSupplyList establishment_id={id} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FuelSupply;
